"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VcfTripStatisticsClient = exports.dataTypeEnum = exports.requestTypeEnum = void 0;
var requestTypeEnum;
(function (requestTypeEnum) {
    requestTypeEnum["GET"] = "GET";
    requestTypeEnum["DELETE"] = "DELETE";
})(requestTypeEnum || (exports.requestTypeEnum = requestTypeEnum = {}));
var vehicleType;
(function (vehicleType) {
    vehicleType["ELECTRIC"] = "electric";
    vehicleType["HYBRID"] = "hybrid";
    vehicleType["GAS"] = "gas";
    vehicleType["FUEL"] = "fuel";
})(vehicleType || (vehicleType = {}));
var dataTypeEnum;
(function (dataTypeEnum) {
    dataTypeEnum["SHORTTERM"] = "shortterm";
    dataTypeEnum["LONGTERM"] = "longterm";
    dataTypeEnum["CYCLIC"] = "cyclic";
})(dataTypeEnum || (exports.dataTypeEnum = dataTypeEnum = {}));
/** /tripdata docs:
 * https://cardata.apps.emea.vwapps.io/documentation#tag/Trip-Statistics
 */
class VcfTripStatisticsClient {
    constructor(authService, stage, gdcType) {
        this.authService = authService;
        this.stage = stage;
        this.gdcType = gdcType;
        this.headers = {
            'User-Id': '__userId__',
            'Content-Type': 'application/json',
        };
        this.resourceHostId = `myvw-vcf-${this.stage}`;
    }
    async getLastShortTermTripData(vin) {
        const url = `vehicles/${vin}/tripdata/${dataTypeEnum.SHORTTERM}/last?gdc=${this.gdcType}`;
        const response = await this.authService.get(this.resourceHostId, url, this.headers);
        if (response.status === 204) {
            return null;
        }
        if (!response.ok) {
            throw new Error(`Request to /tripdata failed with status code ${response.status}`);
        }
        return await response.json();
    }
    async getShortTermTripData(vin) {
        const url = `vehicles/${vin}/tripdata/${dataTypeEnum.SHORTTERM}?gdc=${this.gdcType}`;
        const response = await this.authService.get(this.resourceHostId, url, this.headers);
        if (response.status === 204) {
            return null;
        }
        if (!response.ok) {
            throw new Error(`Request to /tripdata failed with status code ${response.status}`);
        }
        return await response.json();
    }
    async getLongTermTripData(vin) {
        const url = `vehicles/${vin}/tripdata/${dataTypeEnum.LONGTERM}?gdc=${this.gdcType}`;
        const response = await this.authService.get(this.resourceHostId, url, this.headers);
        if (response.status === 204) {
            return null;
        }
        if (!response.ok) {
            throw new Error(`Request to /tripdata failed with status code ${response.status}`);
        }
        return await response.json();
    }
    async getCyclicTermTripData(vin) {
        const url = `vehicles/${vin}/tripdata/${dataTypeEnum.CYCLIC}?gdc=${this.gdcType}`;
        const response = await this.authService.get(this.resourceHostId, url, this.headers);
        if (response.status === 204) {
            return null;
        }
        if (!response.ok) {
            throw new Error(`Request to /tripdata failed with status code ${response.status}`);
        }
        return await response.json();
    }
    async getShortTermRange(vin, range, wholeDay) {
        const fromRange = wholeDay ? new Date(range.from.setHours(0, 0, 0, 0)).toISOString() : range.from.toISOString();
        const toRange = wholeDay ? new Date(range.to.setHours(23, 59, 59, 999)).toISOString() : range.to.toISOString();
        const url = `vehicles/${vin}/tripdata/${dataTypeEnum.SHORTTERM}?gdc=${this.gdcType}&from=${fromRange}&to=${toRange}`;
        const response = await this.authService.get(this.resourceHostId, url, this.headers);
        if (response.status === 204) {
            return null;
        }
        if (!response.ok) {
            throw new Error(`Request to /tripdata failed with status code ${response.status}`);
        }
        return await response.json();
    }
    async getLongTermRange(vin, range, wholeDay) {
        const fromRange = wholeDay ? new Date(range.from.setHours(0, 0, 0, 0)).toISOString() : range.from.toISOString();
        const toRange = wholeDay ? new Date(range.to.setHours(23, 59, 59, 999)).toISOString() : range.to.toISOString();
        const url = `vehicles/${vin}/tripdata/${dataTypeEnum.LONGTERM}?gdc=${this.gdcType}&from=${fromRange}&to=${toRange}`;
        const response = await this.authService.get(this.resourceHostId, url, this.headers);
        if (response.status === 204) {
            return null;
        }
        if (!response.ok) {
            throw new Error(`Request to /tripdata failed with status code ${response.status}`);
        }
        return await response.json();
    }
    async getCyclicTermRange(vin, range, wholeDay) {
        const fromRange = wholeDay ? new Date(range.from.setHours(0, 0, 0, 0)).toISOString() : range.from.toISOString();
        const toRange = wholeDay ? new Date(range.to.setHours(23, 59, 59, 999)).toISOString() : range.to.toISOString();
        const url = `vehicles/${vin}/tripdata/${dataTypeEnum.CYCLIC}?gdc=${this.gdcType}&from=${fromRange}&to=${toRange}`;
        const response = await this.authService.get(this.resourceHostId, url, this.headers);
        if (response.status === 204) {
            return null;
        }
        if (!response.ok) {
            throw new Error(`Request to /tripdata failed with status code ${response.status}`);
        }
        return await response.json();
    }
    async getLastLongTermTrip(vin) {
        const url = `vehicles/${vin}/tripdata/${dataTypeEnum.LONGTERM}/last?gdc=${this.gdcType}`;
        const response = await this.authService.get(this.resourceHostId, url, this.headers);
        if (response.status === 204) {
            return null;
        }
        if (!response.ok) {
            throw new Error(`Request to /tripdata failed with status code ${response.status}`);
        }
        return await response.json();
    }
    async getLastCyclicTermTrip(vin) {
        const url = `vehicles/${vin}/tripdata/${dataTypeEnum.CYCLIC}/last?gdc=${this.gdcType}`;
        const response = await this.authService.get(this.resourceHostId, url, this.headers);
        if (response.status === 204) {
            return null;
        }
        if (!response.ok) {
            throw new Error(`Request to /tripdata failed with status code ${response.status}`);
        }
        return await response.json();
    }
    async deleteShortTermTrips(vin) {
        const url = `vehicles/${vin}/tripdata/${dataTypeEnum.SHORTTERM}?gdc=${this.gdcType}`;
        const response = await this.authService.delete(this.resourceHostId, url, undefined, this.headers);
        if (!response.ok || response.status !== 202) {
            throw new Error(`Request to /tripdata failed with status code ${response.status} and message ${response.statusText}`);
        }
    }
    async deleteLongTermTrips(vin) {
        const url = `vehicles/${vin}/tripdata/${dataTypeEnum.LONGTERM}?gdc=${this.gdcType}`;
        const response = await this.authService.delete(this.resourceHostId, url, undefined, this.headers);
        if (!response.ok || response.status !== 202) {
            throw new Error(`Request to /tripdata failed with status code ${response.status} and message ${response.statusText}`);
        }
    }
    async deleteCyclicTermTrips(vin) {
        const url = `vehicles/${vin}/tripdata/${dataTypeEnum.CYCLIC}?gdc=${this.gdcType}`;
        const response = await this.authService.delete(this.resourceHostId, url, undefined, this.headers);
        if (!response.ok || response.status !== 202) {
            throw new Error(`Request to /tripdata failed with status code ${response.status} and message ${response.statusText}`);
        }
    }
    async deleteShortTermTripRange(vin, range, wholeDay) {
        const fromRange = wholeDay ? new Date(range.from.setHours(0, 0, 0, 0)).toISOString() : range.from.toISOString();
        const toRange = wholeDay ? new Date(range.to.setHours(23, 59, 59, 999)).toISOString() : range.to.toISOString();
        const url = `vehicles/${vin}/tripdata/${dataTypeEnum.SHORTTERM}?gdc=${this.gdcType}&from=${fromRange}&to=${toRange}`;
        const response = await this.authService.delete(this.resourceHostId, url, undefined, this.headers);
        if (!response.ok || response.status !== 202) {
            throw new Error(`Request to /tripdata failed with status code ${response.status} and message ${response.statusText}`);
        }
    }
    async deleteLongTermTripRange(vin, range, wholeDay) {
        const fromRange = wholeDay ? new Date(range.from.setHours(0, 0, 0, 0)).toISOString() : range.from.toISOString();
        const toRange = wholeDay ? new Date(range.to.setHours(23, 59, 59, 999)).toISOString() : range.to.toISOString();
        const url = `vehicles/${vin}/tripdata/${dataTypeEnum.LONGTERM}?gdc=${this.gdcType}&from=${fromRange}&to=${toRange}`;
        const response = await this.authService.delete(this.resourceHostId, url, undefined, this.headers);
        if (!response.ok || response.status !== 202) {
            throw new Error(`Request to /tripdata failed with status code ${response.status} and message ${response.statusText}`);
        }
    }
    async deleteCyclicTermTripRange(vin, range, wholeDay) {
        const fromRange = wholeDay ? new Date(range.from.setHours(0, 0, 0, 0)).toISOString() : range.from.toISOString();
        const toRange = wholeDay ? new Date(range.to.setHours(23, 59, 59, 999)).toISOString() : range.to.toISOString();
        const url = `vehicles/${vin}/tripdata/${dataTypeEnum.CYCLIC}?gdc=${this.gdcType}&from=${fromRange}&to=${toRange}`;
        const response = await this.authService.delete(this.resourceHostId, url, undefined, this.headers);
        if (!response.ok || response.status !== 202) {
            throw new Error(`Request to /tripdata failed with status code ${response.status} and message ${response.statusText}`);
        }
    }
    async deleteShortTermTrip(vin, id) {
        const url = `vehicles/${vin}/tripdata/${dataTypeEnum.SHORTTERM}/${id}?gdc=${this.gdcType}`;
        const response = await this.authService.delete(this.resourceHostId, url, undefined, this.headers);
        if (!response.ok || response.status !== 202) {
            throw new Error(`Request to /tripdata failed with status code ${response.status} and message ${response.statusText}`);
        }
    }
}
exports.VcfTripStatisticsClient = VcfTripStatisticsClient;
//# sourceMappingURL=VcfTripStatisticsClient.js.map